import { useTableLayoutFromSettings } from '@Hooks/TableLayout/useTableLayoutFromSettings';
import { LinkedField, type ILinkable, type ILinkInputProperties } from '@synqo/frontend-component-library';
import { EnumFrontendLayoutSetting } from '@Model';

export interface LinkedFieldWithLayoutSettingsProps<TData extends ILinkable> extends ILinkInputProperties<TData> {
    layoutSettingsContext: EnumFrontendLayoutSetting;
}

export function LinkedFieldWithLayoutSettings<TData extends ILinkable>({
    layoutSettingsContext,
    ...props
}: LinkedFieldWithLayoutSettingsProps<TData>) {
    const {
        columnSizing: modalColumnSizing,
        columnVisibility: modalColumnVisibility,
        updateSizing: updateModalSizing,
        updateVisibility: updateModalVisibility,
    } = useTableLayoutFromSettings(layoutSettingsContext, props.columns);

    const tableModalProps = {
        ...props.tableModalProps,
        columnSizing: modalColumnSizing,
        columnVisibility: modalColumnVisibility,
        onSizesChange: updateModalSizing,
        onVisibilityChange: updateModalVisibility,
    };

    return <LinkedField {...props} tableModalProps={tableModalProps} />;
}
